interface DrawerState {
  isSmall: boolean
}

interface DrawerStateProps {
  isSmall: ComputedRef<boolean>
}

export const DrawerContext = Symbol('DrawerContext') as InjectionKey<DrawerState>
export const useDrawer = () => {
  const context = inject(DrawerContext, null)
  return context
}

export const injectDrawerContext = (props: DrawerStateProps) => {
  provide(DrawerContext, reactive(props))
}
